export default __webpack_public_path__ + "static/media/h23koritu.bf927731.mp3";